import React from "react";
import { Link } from "react-router-dom";

export const WorkshopPreview = (props) => {
  if (!props.data) return "loading";

  return (
    <div id="workshop-preview" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Workshops</h2>
          <p>
            Create unforgettable memories with hands-on cake decorating
            workshops
          </p>
        </div>

        <div className="workshop-preview-grid">
          <div className="workshop-preview-card">
            <div className="workshop-preview-content">
              <div className="workshop-preview-icon">
                <img
                  src="/img/icons/oven.png"
                  alt="Oven"
                  style={{ width: "80px", height: "80px" }}
                />
              </div>
              <h3>Workshops</h3>
              <p>
                Join my scheduled workshops to learn specific decorating
                techniques. From baking a simple dessert to making an
                outstanding shaped design.{" "}
                <span style={{ fontWeight: "bold", color: "#ac3b61" }}>
                  Suitable for all skill levels.
                </span>
              </p>
              <img
                src="https://artcake-gallery.s3.us-east-1.amazonaws.com/workshop.jpg"
                alt="Workshop"
                style={{
                  width: "100%",
                  maxWidth: "320px",
                  height: "auto",
                  borderRadius: "8px",
                  margin: "0 0 20px 0",
                }}
              />
              <div className="workshop-preview-features">
                <div className="feature-item">
                  <i className="fa fa-check"></i>
                  <span>Structured learning</span>
                </div>
                <div className="feature-item">
                  <i className="fa fa-check"></i>
                  <span>Expert instruction</span>
                </div>
                <div className="feature-item">
                  <i className="fa fa-check"></i>
                  <span>Take home your work</span>
                </div>
              </div>

              <button
                className="btn btn-custom btn-lg"
                disabled
                style={{ cursor: "not-allowed", opacity: 0.6 }}
              >
                More Info
              </button>
            </div>
          </div>

          <div className="workshop-preview-card">
            <div className="workshop-preview-content">
              <div className="workshop-preview-icon">
                <img
                  src="/img/icons/people.png"
                  alt="People"
                  style={{ width: "80px", height: "80px" }}
                />
              </div>
              <h3>Private Group Workshops</h3>
              <p>
                Perfect for birthdays, team building, bridal parties, or any
                special celebration. Learn the art of cake decorating in a fun,
                relaxed environment with your friends and family.
              </p>
              <img
                src="https://artcake-gallery.s3.us-east-1.amazonaws.com/workshop-2.jpg"
                alt="Private Group Workshop"
                style={{
                  width: "100%",
                  maxWidth: "320px",
                  height: "auto",
                  borderRadius: "8px",
                  margin: "0 0 20px 0",
                }}
              />
              <div className="workshop-preview-features">
                <div className="feature-item">
                  <i className="fa fa-check"></i>
                  <span>Customized for your group</span>
                </div>
                <div className="feature-item">
                  <i className="fa fa-check"></i>
                  <span>All materials included</span>
                </div>
                <div className="feature-item">
                  <i className="fa fa-check"></i>
                  <span>Take home your creations</span>
                </div>
              </div>

              <button
                className="btn btn-custom btn-lg"
                disabled
                style={{ cursor: "not-allowed", opacity: 0.6 }}
              >
                Book a Custom Workshop
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
